import { 
  Component,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  OnInit,
  Input
} from '@angular/core';

import { DynamicItem } from '../../models/dynamicItem';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {

  /**
   * data in dynamicItem contains data to be passed to popup as well as below fields
   * {
   *    successCallback: callback to be triggered on confirm
   *    cancelCallback: [Optional] callback to be triggered on cancel
   * }
   */
  @Input() dynamicItem: DynamicItem;

  componentRef: any;
  @ViewChild('popupContent', { read: ViewContainerRef }) viewContainerRef: ViewContainerRef;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    ) { }

  createComponent() {
      this.viewContainerRef.clear();
      
      const factory = this.componentFactoryResolver.resolveComponentFactory(this.dynamicItem.component);
      this.componentRef = this.viewContainerRef.createComponent(factory);
      
      //Callback to be triggered on popup confirm/cancel to destroy the component
      this.dynamicItem.data.popupComponentClose = this.destroyComponent.bind(this);
      this.componentRef.instance.data = this.dynamicItem.data;

      document.getElementsByTagName('body')[0].style.overflow = 'hidden';
  }

  ngOnInit() {
    this.createComponent();
  }
  
  destroyComponent() {
    document.getElementsByTagName('body')[0].style.overflow = 'auto';
    this.componentRef.destroy();
  }

}
